import { render, staticRenderFns } from "./LegacyReferralCharts.vue?vue&type=template&id=17301f28&"
import script from "./LegacyReferralCharts.vue?vue&type=script&lang=ts&"
export * from "./LegacyReferralCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports